// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qx-2";
export var chatLink = "_qx-0";
export var chatText = "_qx-1";